import { useState } from 'react';
import {
  useProductsFilter,
  ArrayFilterKeys,
} from '../../../../Context/ProductsFilterContext';
import styles from './ActiveFilterItems.module.scss?module';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';

const ActiveFilterItems = () => {
  const {
    toggleArrayFilter,
    filters,
    setSingleFilter,
    activeFiltersWithLabels,
  } = useProductsFilter();

  const hasActive =
    Object.values(activeFiltersWithLabels).some(
      (list) => list && list.length > 0
    ) || !!filters.q;

  if (!hasActive)
    return <div className={clsx(styles.ActiveFilterItemsContainer)} />;

  const handleRemove = (filterKey: string, value: string | number) => {
    toggleArrayFilter(filterKey as ArrayFilterKeys, value);
  };

  return (
    <div className={clsx(styles.ActiveFilterItemsContainer)}>
      {filters.q && (
        <ActiveFilterItem
          key="q-filter"
          label={`Search Results for: "${filters.q}"`}
          onRemove={() => setSingleFilter('q', null)}
        />
      )}
      {Object.entries(activeFiltersWithLabels).map(([filterKey, options]) =>
        options.map((option) => (
          <ActiveFilterItem
            key={`${filterKey}-${option.value}`}
            label={option.name}
            onRemove={() => handleRemove(filterKey, option.value)}
          />
        ))
      )}
    </div>
  );
};
export default ActiveFilterItems;

interface ActiveFilterItemProps {
  label: string;
  onRemove: () => void;
}

const ActiveFilterItem = ({ label, onRemove }: ActiveFilterItemProps) => {
  const [isExiting, setIsExiting] = useState(false);

  const handleClick = () => {
    setIsExiting(true);
    setTimeout(() => {
      onRemove();
    }, 100);
  };

  return (
    <div
      className={clsx(styles.ActiveFilterItem, isExiting && styles.exiting)}
      onClick={handleClick}
    >
      <span>{label}</span>
      <FontAwesomeIcon icon={faTimes} />
    </div>
  );
};
